/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdInfo } from 'react-icons/md';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import {
  formatCurrency,
  getCabinBaggage,
  getNumSeats,
  getSupplierName,
  isEmpty,
  showSupplier,
  getValueFromAppConfig,
} from '../../shared/helper-utils/appUtils';

import AppLink from '../../shared/components/app-link/AppLink';
import AppButton from '../../shared/components/app-button/AppButton';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import { getBrandedFaresApi } from '../../api/flightApi';
import AppModal from '../../shared/components/app-modal/AppModal';
import ResultCardFlightInfo from '../roundt-trip-intl/ResultCardFlightInfo';
import { useAppContext } from '../../saas/AppConfigWrapper';
import FareCard, {
  getClassInfoRows,
} from '../../shared/components/fare-card/FareCard';
import FareBreakup from '../../shared/components/fare-card/FareBreakup';

// Multi city fares carry per sector arrays ([[..]]); returns the first scalar.
const getFirstValue = (value) =>
  Array.isArray(value) ? getFirstValue(value[0]) : value;

const getLegSeats = (flt) =>
  flt?.flightlegs?.map((leg) => leg.numseatsavailable) || [];

export default function OneWayFareComponent({
  fare,
  userSelectedFare,
  setUserSelectedFare,
  fareInclusions,
  searchRequest,
  showInvoiceFare,
  handleFareRulesClick,
  flight,
  handleShowMiniFareRules,
  handleBook,
  handleSelectForEmail,
  isFareSelectedForEmail,
  setIsLoading,
  journeyType,
  domint,
  isintlMultiCity,
  returnFlight,
  isAmPmFormat,
  isRtIntl = false,
}) {
  const { appConfig } = useAppContext();
  const [showBrandedfares, setShowBrandedfares] = useState(false);
  const [brandedFares, setBrandedFares] = useState([]);
  const getWaterMarkForFare = () => {
    let watermark = '';
    for (let i = 0; i < 100; i++) {
      watermark += `${getUserAgentId()} `;
    }
    return watermark;
  };

  const getMealSeatForFare = (fareType) => {
    try {
      const fareTypeArr = ['indigo super', 'akasa air flexi', 'indigo flexi'];
      if (fareTypeArr.indexOf(fareType.toLowerCase()) > -1) {
        return 'Included';
      }
      return 'chargeable';
    } catch (error) {
      return 'chargeable';
    }
  };

  const handleShowBrandedFares = async () => {
    if (brandedFares.length === 0) {
      setIsLoading(true);
      const res = await getBrandedFaresApi(
        searchRequest,
        fare.nextraflightkey,
        getUserAgentId(),
        journeyType,
        domint,
      );
      if (
        res &&
        res.flightjourneys[0] !== '' &&
        res.flightjourneys[0] !== undefined
      ) {
        const flightOptions = Array.isArray(res.flightjourneys[0].flightoptions)
          ? res.flightjourneys[0].flightoptions
          : [res.flightjourneys[0].flightoptions];
        const isTotalNet = getValueFromAppConfig('sortingtotalnet') === 'true';
        flightOptions.sort((flightOption1, flightOption2) =>
          isTotalNet
            ? flightOption1.recommendedflight[0].flightfare.totalnet -
              flightOption2.recommendedflight[0].flightfare.totalnet
            : flightOption1.recommendedflight[0].flightfare.totalfq -
              flightOption2.recommendedflight[0].flightfare.totalfq,
        );
        const list = [];
        flightOptions.forEach((fo) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const returnBookingClassList = [];
          const returnWeightList = [];
          const returnUnitList = [];
          const returnSeatsList = [];
          const returnCarrierList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
          });
          const fr = fo.recommendedflight[0].flightfare;
          let supplierName = fo.recommendedflight[0].supplier;
          if (isEmpty(supplierName)) {
            const isAmadeus = fo.recommendedflight[0].nextracustomstr
              .split(',')
              .some((word) => word.includes('AMADEUS'));
            if (isAmadeus) {
              supplierName = 'amadeus';
            }
          }
          if (isRtIntl) {
            fo.recommendedflight[1].flightlegs.forEach((leg) => {
              returnCarrierList.push(leg.carrier);
              returnUnitList.push(leg.bagunit);
              returnWeightList.push(leg.bagweight);
              returnSeatsList.push(leg.numseatsavailable);
              returnBookingClassList.push(leg.bookingclass);
            });
          }

          fr.supplierName = supplierName;
          fr.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fr.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fr.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fr.airFreeText = airFreeTextList;
          fr.flightCarrier = carrierList;
          fr.numseatsavailable = seatsList;
          fr.flightBagWeight = bagList;
          fr.flightBagUnit = weighlist;
          fr.bookingClass = bookingClassList;
          fr.flightCarrierReturn = returnCarrierList;
          fr.flightBagWeightReturn = returnWeightList;
          fr.flightBagUnitReturn = returnUnitList;
          fr.returnNumseatsavailable = returnSeatsList;
          fr.returnBookingClass = returnBookingClassList;
          fr.isBrandedFare = true;
          list.push(fr);
        });
        setBrandedFares(list);
      }
      setIsLoading(false);
    }
    setShowBrandedfares(!showBrandedfares);
  };

  const renderBrandedFaresModal = (brandedFareList) => (
    <AppModal
      modalTitle="Branded Fares"
      showCloseButton
      size="lg"
      onModalClose={() => setShowBrandedfares(false)}
      className="branded-fares-modal"
    >
      <ResultCardFlightInfo
        flight={flight}
        isOnward
        userSelectedFare={userSelectedFare}
        isAmPmFormat={isAmPmFormat}
        searchRequest={searchRequest}
        hideLegInfo
      />
      {journeyType === 'roundtrip' &&
        domint === 'international' &&
        returnFlight && (
          <ResultCardFlightInfo
            flight={returnFlight}
            isOnward={false}
            userSelectedFare={userSelectedFare}
            isAmPmFormat={isAmPmFormat}
            searchRequest={searchRequest}
            hideLegInfo
          />
        )}
      {brandedFareList}
    </AppModal>
  );

  // Seats per trip, so the fare card can show the least available count.
  const getFareSeatGroups = (currentFare) => {
    if (isRtIntl) {
      return [
        {
          label: 'Onward',
          seats: currentFare.numseatsavailable || getLegSeats(flight),
        },
        {
          label: 'Return',
          seats:
            currentFare.returnNumseatsavailable || getLegSeats(returnFlight),
        },
      ];
    }
    const seats = currentFare.numseatsavailable || [];
    if (isintlMultiCity && seats.some(Array.isArray)) {
      return seats.map((tripSeats, tripIndex) => ({
        label: `Trip ${tripIndex + 1}`,
        seats: tripSeats,
      }));
    }
    return [{ seats }];
  };

  const getFareClassRows = (currentFare) =>
    isRtIntl && currentFare.returnBookingClass?.length > 0
      ? getClassInfoRows(
          [currentFare.bookingClass, currentFare.returnBookingClass],
          ['Onward', 'Return'],
        )
      : getClassInfoRows(currentFare.bookingClass);

  // New fare card with inclusions & penalties (toggle: FareCardWithInclusion
  // in saas/AppConfigWrapper.jsx).
  const renderFareCardWithInclusion = () => {
    const isGatewayFlight =
      flight?.nextracustomstr?.includes('iweenflightgateway');
    const carrierInclusion = fareInclusions?.[fare.flightCarrier?.[0]];
    const fareTypeInclusion = isGatewayFlight
      ? null
      : fareInclusions?.[fare.faretype];
    const isSeatCountHidden =
      fare.supplierName === 'airarabia' || fare.supplierName === 'uapindc';

    const getFareRulesLinks = (currentFare) => (
      <>
        <AppLink
          linkText="Fare Rules"
          variant="secondary"
          className="fs-14"
          onClick={() => handleFareRulesClick(currentFare)}
        />
        {currentFare.isminifarerulesrequired === 'true' && (
          <AppLink
            linkText="Mini Fare rules"
            variant="secondary"
            className="fs-12"
            onClick={() => handleShowMiniFareRules(currentFare)}
          />
        )}
      </>
    );

    const getShareCheckbox = (currentFare) => (
      <AppCheckBox
        name="emailorwhatsapp"
        id={currentFare.nextraflightkey}
        labelText="Share via Email or WhatsApp"
        onChange={() => handleSelectForEmail(currentFare)}
        checked={isFareSelectedForEmail(currentFare)}
      />
    );

    return (
      <>
        <FareCard
          fare={fare}
          watermark={getWaterMarkForFare()}
          isSelected={fare.nextraflightkey === userSelectedFare.nextraflightkey}
          onSelect={setUserSelectedFare}
          topActions={
            <>
              {fare?.faretype_supplier?.toLowerCase() === 'ndc' && (
                <div className="fare-type-supplier">NDC Fare</div>
              )}
              {fare?.ismorefaresavailable === 'true' && (
                <AppLink
                  linkText="More Fares"
                  className="more-fares-link"
                  onClick={handleShowBrandedFares}
                />
              )}
            </>
          }
          priceClassName={
            appConfig?.ShowTboPriceBlack === 'true' &&
            fare?.supplierName?.toLowerCase() === 'tbo'
              ? ''
              : 'primary-color'
          }
          showInvoiceFare={showInvoiceFare}
          fareBreakup={
            <FareBreakup fare={fare} showInvoiceFare={showInvoiceFare} />
          }
          isSeriesFare={searchRequest.searchtype === 'seriesfares'}
          legacyInclusion={carrierInclusion}
          checkinFallback={
            fareTypeInclusion?.Checkin ||
            getCabinBaggage(
              getFirstValue(fare?.flightBagWeight),
              getFirstValue(fare?.flightBagUnit),
            )
          }
          cabinFallback={
            fareTypeInclusion?.HandBaggage ||
            getCabinBaggage(
              getFirstValue(fare?.cabinBagweight),
              getFirstValue(fare?.cabinBagunit),
            )
          }
          infoRows={[
            ...getFareClassRows(fare),
            ...(showSupplier()
              ? [
                  {
                    label: 'Supplier',
                    value: getSupplierName(fare.supplierName),
                    className: 'suppiler',
                  },
                ]
              : []),
          ]}
          seatGroups={isSeatCountHidden ? [] : getFareSeatGroups(fare)}
          links={getFareRulesLinks(fare)}
          onBook={handleBook}
          footer={
            <>
              {getShareCheckbox(fare)}
              {fare.airFreeText?.length > 0 && (
                <div className="fs-12 green-color">
                  {fare.airFreeText.join(',')}
                </div>
              )}
            </>
          }
        />
        {showBrandedfares &&
          renderBrandedFaresModal(
            <div className="d-flex align-items-stretch gap-2 overflow-auto mt-2 pb-2">
              {brandedFares.length > 0 ? (
                brandedFares.map((brandedFare) => (
                  <FareCard
                    key={brandedFare.nextraflightkey}
                    fare={brandedFare}
                    watermark={getWaterMarkForFare()}
                    isSelected={
                      brandedFare.nextraflightkey ===
                      userSelectedFare.nextraflightkey
                    }
                    onSelect={setUserSelectedFare}
                    showInvoiceFare={showInvoiceFare}
                    fareBreakup={
                      <FareBreakup
                        fare={brandedFare}
                        showInvoiceFare={showInvoiceFare}
                        searchRequest={searchRequest}
                        isPaxWise
                      />
                    }
                    checkinFallback={getCabinBaggage(
                      getFirstValue(brandedFare.flightBagWeight),
                      getFirstValue(brandedFare.flightBagUnit),
                    )}
                    cabinFallback={getCabinBaggage(
                      getFirstValue(brandedFare.cabinBagweight),
                      getFirstValue(brandedFare.cabinBagunit),
                    )}
                    infoRows={[
                      ...getFareClassRows(brandedFare),
                      {
                        label: 'Supplier',
                        value: getSupplierName(brandedFare.supplierName),
                      },
                    ]}
                    seatGroups={getFareSeatGroups(brandedFare)}
                    links={getFareRulesLinks(brandedFare)}
                    onBook={(selectedBrandedFare) => {
                      setShowBrandedfares(false);
                      handleBook(selectedBrandedFare);
                    }}
                    footer={getShareCheckbox(brandedFare)}
                  />
                ))
              ) : (
                <div>Branded fares are not available</div>
              )}
            </div>,
          )}
      </>
    );
  };

  if (appConfig?.FareCardWithInclusion) {
    return renderFareCardWithInclusion();
  }

  return (
    <>
      <div
        className={`fare-component-mobile ${
          fare.isBrandedFare ? 'branded-border' : ''
        } fare-component-watermark ${
          fare.nextraflightkey === userSelectedFare.nextraflightkey
            ? 'light-background-color'
            : ''
        }`}
        // onClick={() => handleFareSelection(fare)}
        data-watermark={getWaterMarkForFare()}
      >
        <div className="d-flex justify-content-between flex-column h-100 fareCard">
          <div className="watermark-actions d-flex justify-content-between align-items-center">
            <AppRadioInput
              id={fare.nextraflightkey}
              name={fare.nextraflightkey}
              radioClassName="radioButton"
              checked={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
              }
              onChange={() => setUserSelectedFare(fare)}
              labelText={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
                  ? 'Selected'
                  : 'Select'
              }
            />
            {fare?.faretype_supplier?.toLowerCase() === 'ndc' && (
              <div className="fare-type-supplier">NDC Fare</div>
            )}
            {fare?.ismorefaresavailable === 'true' && (
              <AppLink
                linkText="More Fares"
                className="more-fares-link"
                onClick={handleShowBrandedFares}
              />
            )}
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-start gap-2">
              <span className="fare-component_title">Fare Type</span>
              <span className="fs-14 fw-600 text-capitalize fare-type-span text-end">
                <span className="fareType">{fare.faretype}</span>
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cancellation</span>
              <span className="fare-component_value">
                {fareInclusions && fareInclusions[fare.flightCarrier[0]]
                  ? fareInclusions[fare.flightCarrier[0]]?.Cancellation
                  : 'Chargeable'}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Reschedule</span>
              <span className="fare-component_value">
                {' '}
                {fareInclusions && fareInclusions[fare.flightCarrier[0]]
                  ? fareInclusions[fare.flightCarrier[0]]?.Reissue
                  : 'Chargeable'}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Meal</span>
              <span className="fare-component_value">
                {fareInclusions && fareInclusions[fare.flightCarrier[0]]
                  ? fareInclusions[fare.flightCarrier[0]]?.MealIncluded
                  : getMealSeatForFare(fare.faretype)}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Seat</span>
              <span className="fare-component_value">
                {fareInclusions && fareInclusions[fare.flightCarrier[0]]
                  ? fareInclusions[fare.flightCarrier[0]]?.SeatIncluded
                  : getMealSeatForFare(fare.faretype)}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Check In</span>
              <span className="fare-component_value checkIn">
                {/* {getCabinBaggage(
                  fare?.flightBagWeight[0],
                  fare?.flightBagUnit[0],
                )}
                 {fareInclusions &&
                fareInclusions[fare.flightCarrier[0]]?.Checkin
                  ? fareInclusions[fare.flightCarrier[0]]?.Checkin
                  : getCabinBaggage(
                      fare.flightBagWeight[0],
                      fare.flightBagUnit[0],
                    )}  */}
                {flight?.nextracustomstr?.includes('iweenflightgateway')
                  ? getCabinBaggage(
                      fare?.flightBagWeight?.[0],
                      fare?.flightBagUnit?.[0],
                    )
                  : fareInclusions?.[fare?.faretype]?.Checkin
                  ? fareInclusions[fare.faretype].Checkin
                  : getCabinBaggage(
                      fare?.flightBagWeight?.[0],
                      fare?.flightBagUnit?.[0],
                    )}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cabin</span>
              <span className="fare-component_value cabin">
                {flight?.nextracustomstr?.includes('iweenflightgateway')
                  ? getCabinBaggage(
                      flight?.flightlegs?.[0]?.cabinBagweight,
                      flight?.flightlegs?.[0]?.cabinBagunit,
                    )
                  : fareInclusions[fare.faretype]?.HandBaggage
                  ? fareInclusions[fare.faretype]?.HandBaggage
                  : '7Kg'}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Class</span>
              <span className="fare-component_value class">
                {fare.bookingClass.join(',')}
              </span>
            </div>
            {showSupplier() && (
              <div className="d-flex justify-content-between align-items-center">
                <span className="fare-component_title">Supplier</span>
                <span className="fare-component_value suppiler">
                  {getSupplierName(fare.supplierName)}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center mt-1">
              {searchRequest.searchtype === 'seriesfares' ? (
                <span className="fare_non-refundable reFundableInfo">
                  Non Refundable/ <br /> Non changeable
                </span>
              ) : (
                <span className="fare-component_value">
                  {fare.refundableinfo === 'Y' ? (
                    <span className="fare_refundable reFundableInfo">
                      Refundable
                    </span>
                  ) : fare.refundableinfo === 'PR' ? (
                    <span className="fare_partial-refundable reFundableInfo">
                      Partially Refundable
                    </span>
                  ) : (
                    <span className="fare_non-refundable reFundableInfo">
                      Non Refundable
                    </span>
                  )}
                </span>
              )}
              <span className="fs-12 red-color fw-600">
                {fare.supplierName !== 'airarabia' &&
                fare.supplierName !== 'uapindc' &&
                fare.numseatsavailable &&
                fare.numseatsavailable.length > 0 &&
                parseInt(fare.numseatsavailable[0], 10) > 0 ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip
                        id={`available-seats-tooltip-${
                          fare.nextraflightkey || 'fare'
                        }`}
                      >
                        Seats left: {fare.numseatsavailable.join(', ')}
                      </Tooltip>
                    }
                  >
                    <span style={{ cursor: 'pointer' }}>
                      {getNumSeats(fare.numseatsavailable[0])} seats left
                    </span>
                  </OverlayTrigger>
                ) : (
                  ''
                )}
              </span>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center my-2 watermark-actions">
              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex flex-column">
                  <div className="fs-16 fw-600 primary-color totalFare">
                    {formatCurrency(fare.totalfq)}
                  </div>
                  {showInvoiceFare && (
                    <div className="fs-12 secondary-color">
                      {formatCurrency(fare.totalnet)}
                    </div>
                  )}
                </div>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="fare-breakup-tooltip">
                      <div className="fare-breakup">
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Base Fare</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totalbasefare)}
                          </div>
                        </div>
                        {/* <div className="fare-breakup_content">
                    <div className="fare-breakup_title">YQ Tax</div>
                    <div className="fare-breakup_value">
                      {formatCurrency(getYQForTheFare(fare))}
                    </div>
                  </div> */}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Tax</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totaltax)}
                          </div>
                        </div>
                        {/* <div className="fare-breakup_content">
                    <div className="fare-breakup_title">K3</div>
                    <div className="fare-breakup_value">
                      {formatCurrency(getK3ForTheFare(fare))}
                    </div>
                  </div> */}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">HC</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.handlingcharges)}
                          </div>
                        </div>
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">GST</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.servicetax)}
                          </div>
                        </div>
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">
                            Other Charges
                          </div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.transactionfee)}
                          </div>
                        </div>

                        {showInvoiceFare && (
                          <>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">Discount</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.discount)}
                              </div>
                            </div>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">TDS</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.tds)}
                              </div>
                            </div>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">Net Fare</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.totalnet)}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Total Fare</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totalfq)}
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  }
                >
                  <div className="cursor-pointer secondary-color">
                    <MdInfo />
                  </div>
                </OverlayTrigger>
              </div>
              <div className="d-flex flex-column">
                <AppLink
                  linkText="Fare Rules"
                  variant="secondary"
                  className="fs-14"
                  onClick={() => handleFareRulesClick(fare)}
                />
                {/* {!fare.isBrandedFare && (
                
              )} */}
                {fare.isminifarerulesrequired === 'true' && (
                  <AppLink
                    linkText="Mini Fare rules"
                    variant="secondary"
                    className="fs-10"
                    onClick={() => handleShowMiniFareRules(fare)}
                  />
                )}
              </div>
            </div>
            <div className="d-flex my-1 watermark-actions">
              <AppButton
                btnText="Book now"
                variant="primary"
                className="fs-16 flex-1 bookNow"
                onClick={() => handleBook(fare)}
              />
            </div>
            <div className="watermark-actions">
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
            </div>
            {fare.airFreeText.length > 0 && (
              <div className="mt-1 fs-12 green-color">
                {fare.airFreeText.join(',')}
              </div>
            )}
          </div>
        </div>
      </div>
      {showBrandedfares && (
        <AppModal
          modalTitle="Branded Fares"
          showCloseButton
          size="lg"
          onModalClose={() => setShowBrandedfares(false)}
          className="branded-fares-modal"
        >
          <ResultCardFlightInfo
            flight={flight}
            isOnward
            userSelectedFare={userSelectedFare}
            isAmPmFormat={isAmPmFormat}
            searchRequest={searchRequest}
            hideLegInfo
          />
          {journeyType === 'roundtrip' &&
            domint === 'international' &&
            returnFlight && (
              <ResultCardFlightInfo
                flight={returnFlight}
                isOnward={false}
                userSelectedFare={userSelectedFare}
                isAmPmFormat={isAmPmFormat}
                searchRequest={searchRequest}
                hideLegInfo
              />
            )}
          <div className="d-flex align-items-center gap-2 overflow-scroll mt-2">
            {brandedFares.length > 0 ? (
              brandedFares.map((brandedFare, index) => (
                <div
                  key={index}
                  className={`fare-component-mobile branded-border fare-component-watermark ${
                    brandedFare.nextraflightkey ===
                    userSelectedFare.nextraflightkey
                      ? 'fare-component-mobile_selected'
                      : ''
                  }`}
                  data-watermark={getWaterMarkForFare()}
                >
                  <div className="d-flex justify-content-between flex-column h-100">
                    <div className="watermark-actions d-flex justify-content-between align-items-center">
                      <AppRadioInput
                        id={brandedFare.nextraflightkey}
                        name={brandedFare.nextraflightkey}
                        checked={
                          brandedFare.nextraflightkey ===
                          userSelectedFare.nextraflightkey
                        }
                        onChange={() => setUserSelectedFare(brandedFare)}
                        labelText={
                          brandedFare.nextraflightkey ===
                          userSelectedFare.nextraflightkey
                            ? 'Selected'
                            : 'Select'
                        }
                      />
                    </div>
                    <div>
                      <div className="d-flex justify-content-between align-items-start gap-2">
                        <span className="fare-component_title">Fare Type</span>
                        <span className="fs-14 fw-600 text-capitalize fare-type-span text-end">
                          <span className="fareType">
                            {brandedFare.faretype}
                          </span>
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">
                          Cancellation
                        </span>
                        <span className="fare-component_value">chargeable</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">Reschedule</span>
                        <span className="fare-component_value">chargeable</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">Meal</span>
                        <span className="fare-component_value">
                          {fareInclusions &&
                          fareInclusions[fare.flightCarrier[0]]
                            ? fareInclusions[fare.flightCarrier[0]]
                                ?.MealIncluded
                            : getMealSeatForFare(fare.faretype)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">Seat</span>
                        <span className="fare-component_value">chargeable</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">Check In</span>
                        <span className="fare-component_value">
                          {isintlMultiCity
                            ? getCabinBaggage(
                                brandedFare.flightBagWeight[0][0],
                                brandedFare.flightBagUnit[0][0],
                              )
                            : getCabinBaggage(
                                brandedFare.flightBagWeight[0],
                                brandedFare.flightBagUnit[0],
                              )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">Cabin</span>
                        <span className="fare-component_value">7kg</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fare-component_title">Class</span>
                        <span className="fare-component_value">
                          {isintlMultiCity
                            ? brandedFare.bookingClass[0].join(',')
                            : brandedFare.bookingClass.join(',')}
                        </span>
                      </div>
                      {!isEmpty(getSupplierName(brandedFare.supplierName)) && (
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fare-component_title">Supplier</span>
                          <span className="fare-component_value">
                            {getSupplierName(brandedFare.supplierName)}
                          </span>
                        </div>
                      )}
                      <div className="d-flex justify-content-between align-items-center mt-1">
                        <span className="fare-component_value">
                          {brandedFare.refundableinfo === 'Y' ? (
                            <span className="fare_refundable">Refundable</span>
                          ) : (
                            <span className="fare_non-refundable">
                              Non Refundable
                            </span>
                          )}
                        </span>
                        {!isEmpty(brandedFare.numseatsavailable[0]) &&
                          parseInt(brandedFare.numseatsavailable[0], 10) >
                            0 && (
                            <span className="fs-12 red-color fw-600">
                              {brandedFare.numseatsavailable[0]} seats left
                            </span>
                          )}
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-between align-items-center mt-2 watermark-actions">
                        <div className="d-flex gap-2 align-items-center">
                          <div className="d-flex flex-column">
                            <div className="fs-16 fw-600 primary-color fare-totalfq">
                              {formatCurrency(brandedFare.totalfq)}
                            </div>
                            {showInvoiceFare && (
                              <div className="fs-12 secondary-color fare-totalnet">
                                {formatCurrency(brandedFare.totalnet)}
                              </div>
                            )}
                          </div>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="fare-breakup-tooltip">
                                <div className="fare-breakup">
                                  <div className="fare-breakup_content">
                                    <div className="fare-breakup_title">
                                      Adult *
                                      {parseInt(searchRequest.numadults, 10)}
                                    </div>
                                    <div className="fare-breakup_value">
                                      {formatCurrency(
                                        brandedFare.adultbasefare +
                                          brandedFare.adulttax +
                                          brandedFare.transactionfee,
                                      )}
                                    </div>
                                  </div>
                                  {parseInt(searchRequest.numchildren, 10) >
                                    0 && (
                                    <div className="fare-breakup_content">
                                      <div className="fare-breakup_title">
                                        Child *
                                        {parseInt(
                                          searchRequest.numchildren,
                                          10,
                                        )}
                                      </div>
                                      <div className="fare-breakup_value">
                                        {formatCurrency(
                                          brandedFare.childbasefare +
                                            brandedFare.childtax +
                                            brandedFare.transactionfee,
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {parseInt(searchRequest.numinfants, 10) >
                                    0 && (
                                    <div className="fare-breakup_content">
                                      <div className="fare-breakup_title">
                                        Infant *
                                        {parseInt(searchRequest.numinfants, 10)}
                                      </div>
                                      <div className="fare-breakup_value">
                                        {formatCurrency(
                                          brandedFare.infantbasefare +
                                            brandedFare.infanttax,
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="fare-breakup_content">
                                    <div className="fare-breakup_title">
                                      GST
                                    </div>
                                    <div className="fare-breakup_value">
                                      {formatCurrency(brandedFare.servicetax)}
                                    </div>
                                  </div>
                                  <div className="fare-breakup_content">
                                    <div className="fare-breakup_title">
                                      Other Charges
                                    </div>
                                    <div className="fare-breakup_value">
                                      {formatCurrency(
                                        brandedFare.transactionfee,
                                      )}
                                    </div>
                                  </div>

                                  {showInvoiceFare && (
                                    <>
                                      <div className="fare-breakup_content">
                                        <div className="fare-breakup_title">
                                          Discount
                                        </div>
                                        <div className="fare-breakup_value">
                                          {formatCurrency(brandedFare.discount)}
                                        </div>
                                      </div>
                                      <div className="fare-breakup_content">
                                        <div className="fare-breakup_title">
                                          TDS
                                        </div>
                                        <div className="fare-breakup_value">
                                          {formatCurrency(brandedFare.tds)}
                                        </div>
                                      </div>
                                      <div className="fare-breakup_content">
                                        <div className="fare-breakup_title">
                                          Net Fare
                                        </div>
                                        <div className="fare-breakup_value">
                                          {formatCurrency(brandedFare.totalnet)}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  <div className="fare-breakup_content">
                                    <div className="fare-breakup_title">
                                      Total Fare
                                    </div>
                                    <div className="fare-breakup_value">
                                      {formatCurrency(brandedFare.totalfq)}
                                    </div>
                                  </div>
                                </div>
                              </Tooltip>
                            }
                          >
                            <div className="cursor-pointer secondary-color">
                              <MdInfo />
                            </div>
                          </OverlayTrigger>
                        </div>
                        <div className="d-flex flex-column">
                          <AppLink
                            linkText="Fare Rules"
                            variant="secondary"
                            className="fs-14"
                            onClick={() => handleFareRulesClick(brandedFare)}
                          />

                          {brandedFare.isminifarerulesrequired === 'true' && (
                            <AppLink
                              linkText="Mini Fare rules"
                              variant="secondary"
                              className="fs-10"
                              onClick={() =>
                                handleShowMiniFareRules(brandedFare)
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="d-flex my-1 watermark-actions">
                        <AppButton
                          btnText="Book now"
                          variant="primary"
                          className="fs-16 flex-1"
                          onClick={() => {
                            setShowBrandedfares(false);
                            handleBook(brandedFare);
                          }}
                        />
                      </div>
                      <div className="watermark-actions">
                        <AppCheckBox
                          name="emailorwhatsapp"
                          id={brandedFare.nextraflightkey}
                          labelText="Share via Email or WhatsApp"
                          onChange={() => handleSelectForEmail(brandedFare)}
                          checked={isFareSelectedForEmail(brandedFare)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>Brande fares are not available</div>
            )}
          </div>
        </AppModal>
      )}
    </>
  );
}
